import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import Icon from "../../components/Icon";

// O botão de voltar leva ao nível imediatamente acima (o penúltimo item), que
// é o caminho mais comum; a trilha fica para quem quer subir mais.
export const BrandBreadcrumb = ({ items }) => {
    const parent = [...items].reverse().find(item => item.to);

    return (
        <nav className="brand-breadcrumb" aria-label="Navegação">
            {parent &&
                <Link to={parent.to} className="brand-breadcrumb-back" aria-label={`Voltar para ${parent.label}`}>
                    <Icon name="arrow-back" size={16} />
                </Link>
            }
            <ol>
                {items.map((item, index) => (
                    <Fragment key={index}>
                        {index > 0 && <li className="brand-breadcrumb-separator" aria-hidden="true"><Icon name="arrow" size={14} /></li>}
                        <li>
                            {item.to
                                ? <Link to={item.to}>{item.label}</Link>
                                : <span aria-current="page">{item.label}</span>
                            }
                        </li>
                    </Fragment>
                ))}
            </ol>
        </nav>
    );
};

export default BrandBreadcrumb;
